'use client';

import classnames from 'classnames';
import React from 'react';
import slugify from 'slugify';

import Radio from 'molecules/Form/radiogroup/radio';
import styles from 'molecules/Form/radiogroup/radio.module.scss';

import type { FC } from 'react';

type RadioOption = {
  label: string;
  disabled?: boolean;
  formStateProps?: Record<string, unknown>;
};

type RadioGroupProps = {
  legend: string;
  options: RadioOption[];
  required?: boolean;
  valid?: boolean;
  message?: string;
  checked?: boolean;
  validate?: (fieldName: string, value: string, required: boolean) => void;
  validateOnBlur?: (fieldName: string, value: string, required: boolean) => void;
  validateOnChange?: (fieldName: string, value: string, required: boolean) => void;
};

const RadioGroup: FC<RadioGroupProps> = ({
  legend,
  options,
  required = false,
  valid = true,
  validate,
  message = 'This field is required',
  validateOnBlur,
  validateOnChange,
}) => (
  <div
    className={classnames(styles.container, {
      [styles.error]: !valid,
    })}
  >
    <fieldset
      className={classnames(styles.fieldset, {
        [styles.required]: required,
      })}
      data-testid="radioModuleID"
    >
      <legend>{legend}</legend>
      {options?.map(({ label, disabled, formStateProps }) => (
        <Radio
          key={`radio-${slugify(legend)}-${slugify(label)}`}
          label={label}
          validate={validate}
          required={required}
          id={`radio-${slugify(legend)}-${slugify(label)}`}
          disabled={disabled || false}
          formStateProps={formStateProps}
          validateOnBlur={validateOnBlur}
          validateOnChange={validateOnChange}
        />
      ))}
      {!valid && message && (
        <div className={styles.errorMessage} aria-hidden={valid}>
          {message}
        </div>
      )}
    </fieldset>
  </div>
);

export default RadioGroup;
